module.exports = __webpack_public_path__ + "img/T1D_rc-11.fe34c6c8.png";